import React, { useEffect, useState } from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { api } from "@/lib/api";
import { SEO } from "@/lib/seo";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { PlayCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function VideoLibraryPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/videos").then(setItems).catch(() => {}); }, []);
  return (
    <main>
      <SEO title="Video Library" description="Impact reels, awareness films and volunteer stories from CAF." breadcrumbs={[{name: "Home", href:"/"},{name:"Media", href:"/media"},{name:"Video Library", href:"/video-library"}]} jsonLd={items.length ? { "@context":"https://schema.org","@type":"ItemList", itemListElement: items.map((v, i) => ({ "@type":"ListItem", position: i+1, item: { "@type":"VideoObject", name: v.title, thumbnailUrl: v.thumbnail, uploadDate: v.published_at, description: v.title } })) } : undefined} />
      <PageHeader eyebrow="Video Library" title="Watch the work." lead="Short films, explainer videos and stories from the field." />
      <section className="container-wide py-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {items.map((v) => (
          <Dialog key={v.id}>
            <DialogTrigger asChild>
              <button data-testid={`video-card-${v.slug}`} className="group relative aspect-video rounded-2xl overflow-hidden border border-border focus-ring w-full text-left">
                <img src={v.thumbnail} alt={v.title} loading="lazy" className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-black/25 group-hover:bg-black/45 transition-colors" />
                <PlayCircle className="absolute inset-0 m-auto h-14 w-14 text-white/95" />
                <div className="absolute top-3 left-3"><Badge className="badge-orange border">{v.category}</Badge></div>
                <div className="absolute bottom-3 left-3 right-3 text-white"><div className="text-sm font-semibold">{v.title}</div><div className="text-[11px] text-white/80">{v.duration}</div></div>
              </button>
            </DialogTrigger>
            <DialogContent className="max-w-4xl p-0 overflow-hidden bg-black">
              <div className="aspect-video"><iframe title={v.title} src={v.embed_url} className="w-full h-full" allowFullScreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" /></div>
            </DialogContent>
          </Dialog>
        ))}
      </section>
    </main>
  );
}
